function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
  id: "path-1",
  points: "0 0 20 0 30 9.75 30 40 0 40"
}));

var _ref3 = /*#__PURE__*/React.createElement("g", {
  id: "Icons",
  stroke: "none",
  strokeWidth: 1,
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("g", {
  id: "Sep3_Icons_1_",
  transform: "translate(-216.000000, -1846.000000)"
}, /*#__PURE__*/React.createElement("g", {
  id: "Illustrator",
  transform: "translate(0.000000, 1818.000000)"
}, /*#__PURE__*/React.createElement("g", {
  id: "Icon-Main",
  transform: "translate(216.000000, 28.000000)"
}, /*#__PURE__*/React.createElement("mask", {
  id: "mask-2",
  fill: "white"
}, /*#__PURE__*/React.createElement("use", {
  xlinkHref: "#path-1"
})), /*#__PURE__*/React.createElement("use", {
  id: "Shape",
  fill: "#E3E7F4",
  fillRule: "nonzero",
  xlinkHref: "#path-1"
}), /*#__PURE__*/React.createElement("polygon", {
  id: "Rectangle-path",
  fill: "#CFD4E5",
  fillRule: "nonzero",
  mask: "url(#mask-2)",
  points: "20 0 30 0 30 10 20 10"
}), /*#__PURE__*/React.createElement("g", {
  id: "airtable-icon",
  mask: "url(#mask-2)"
}, /*#__PURE__*/React.createElement("g", {
  transform: "translate(6.000000, 14.000000)",
  id: "Path"
}, /*#__PURE__*/React.createElement("path", {
  d: "M8.03758157,0.190005298 L1.3267091,2.96687901 C0.953515674,3.12132535 0.957381745,3.65140667 1.33293577,3.80025661 L8.07188914,6.47264057 C8.66403376,6.70746354 9.32343057,6.70746354 9.91547348,6.47264057 L16.6545286,3.80025661 C17.0299608,3.65140667 17.0339286,3.12132535 16.6606169,2.96687901 L9.94984609,0.190005298 C9.33755612,-0.0633350994 8.6497733,-0.0633350994 8.03758503,0.190005298",
  fill: "#FFCC00"
}), /*#__PURE__*/React.createElement("path", {
  d: "M9.59154409,7.93197222 L9.59154409,14.6079463 C9.59154409,14.9254864 9.91172987,15.1429114 10.2068865,15.0259074 L17.7161365,12.111171 C17.887574,12.0432035 18,11.8775692 18,11.6932106 L18,5.01723656 C18,4.69969642 17.6798142,4.48227146 17.3846576,4.59927544 L9.87540763,7.5140118 C9.70407248,7.58197245 9.59154409,7.74761365 9.59154409,7.93197222",
  fill: "#22C1F4"
}), /*#__PURE__*/React.createElement("path", {
  d: "M7.83808389,8.27643372 L5.60950311,9.35246813 L5.38322659,9.46184237 L0.678829558,11.7159601 C0.380620464,11.8598252 0,11.642502 0,11.3112265 L0,5.04527664 C0,4.92542361 0.0614503207,4.82195087 0.143864458,4.74401509 C0.178256435,4.70952626 0.217221557,4.68113956 0.257714979,4.65865297 C0.370140977,4.59119737 0.530488124,4.57318846 0.666823845,4.62711143 L7.80064222,7.45363592 C8.16325446,7.59750038 8.19174287,8.1056057 7.83808527,8.27643233",
  fill: "#F02C44"
})))))));

var SvgAirtable = function SvgAirtable(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "30px",
    height: "40px",
    viewBox: "0 0 30 40",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgAirtable, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/airtable.ef4bcf05.svg";
export { ForwardRef as ReactComponent };